const BASE_URL = "https://pregbuddyapi.herokuapp.com/"

export const api_url = BASE_URL